// extracted by mini-css-extract-plugin
export default {"formSection":"FormSection_formSection__vcGo1","title":"FormSection_title__qixL0"};